import { render, staticRenderFns } from "./Youtube.vue?vue&type=template&id=8dd9d876"
import script from "./Youtube.vue?vue&type=script&lang=js"
export * from "./Youtube.vue?vue&type=script&lang=js"
import style0 from "./Youtube.vue?vue&type=style&index=0&id=8dd9d876&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports